import { useEffect, useState } from 'react'
import MicrophoneIcon from '../../assets/icons/microphone-blue.svg'
import { ModalBuscaVoz } from '../Modais/ModalBuscaVoz'
import { HISTORICO_BUSCAS, LOCATION_PAGES_VOICE } from '../../constants/storageNames'
import { useNavigate } from 'react-router-dom'

interface Props {
  isOptimizePage?: boolean
}

export default function Voice2TextBusca({isOptimizePage = false}:Props) {
  const [showModalBusca, setShowModalBusca] = useState(false)
  // const navigation = useNavigate()

  const searchEnterprise = (valInput: string) => {
    let pages:string[] = JSON.parse(sessionStorage.getItem(LOCATION_PAGES_VOICE) ?? '[]')
    pages.push(location.pathname)
    sessionStorage.setItem(LOCATION_PAGES_VOICE, JSON.stringify(pages))


    let strBuscaURL = `?voice=true&search=enterprises&fullText=${valInput}`
    if(pages.length >= 1 && ((pages.length % 2 == 0 && pages[pages.length-1] == '/busca/' && pages[pages.length-2] == '/busca/') || pages.length % 2 == 1 && pages[pages.length-1] == '/busca/')){
      window.location.href = (`/busca/${strBuscaURL}`)
    }else{
      // isOptimizePage ? window.location.href = `/busca/${strBuscaURL}` : useNavigate()(`/busca/${strBuscaURL}`)
      window.location.href = `/busca/${strBuscaURL}`
    }
  }

  return (
    <>
      <img src={MicrophoneIcon} className='cursor-pointer' onClick={() => setShowModalBusca(true)} />
      <ModalBuscaVoz
        showModal={showModalBusca}
        closeModal={() => setShowModalBusca(false)}
        valInput={(val) => searchEnterprise(val)}
      />
    </>
  )
}
